<template>
    <f7-page class="page-report has-footer">
        <f7-navbar :sliding="false">
            <f7-nav-left back-link="Trở lại"></f7-nav-left>
            <f7-nav-title sliding>THỐNG KÊ {{ title_play_style(region, playStyle) }}</f7-nav-title>
            <f7-nav-right>
                <f7-link @click.prevent="chooseReportDate">{{ this.selected_drawdate | moment('DD/MM/YYYY') }}</f7-link>
            </f7-nav-right>
            <f7-subnavbar>
                <f7-segmented raised>
                    <f7-button :tab-link="`#tab-thong-ke-` + region" tab-link-active>THỐNG KÊ</f7-button>
                    <f7-button :tab-link="`#tab-du-chuan-` + region">DƯ CHUẨN</f7-button>
                    <f7-button style="width: 100px" @click.prevent="reloadData">
                        <f7-icon ios="f7:arrow_clockwise"></f7-icon>
                    </f7-button>
                    <f7-button style="width: 100px" :tab-link="`#tab-cau-hinh-` + region">
                      <f7-icon ios="f7:gear_alt"></f7-icon>
                    </f7-button>
                </f7-segmented>
            </f7-subnavbar>
        </f7-navbar>
        <ReportNgheAn v-if="playStyle.indexOf('_ngan') >= 0" :region="region" :play-style="playStyle" ref="reportData"></ReportNgheAn>
        <ReportHanoi v-else-if="playStyle.indexOf('_hanoi') >= 0" :region="region" :play-style="playStyle" ref="reportData"></ReportHanoi>
        <ReportBMT v-else-if="playStyle.indexOf('_buonme') >= 0" :region="region" :play-style="playStyle" ref="reportData"></ReportBMT>
        <ReportDefault v-else :region="region" :play-style="playStyle" ref="reportData"></ReportDefault>
        <Footer/>
    </f7-page>
</template>
<script>
import Footer from "@/components/Footer";
import ReportDefault from './components/Default';
import ReportNgheAn from './components/NgheAn';
import ReportHanoi from './components/Hanoi';
import ReportBMT from './components/Bmt';
import { mapState } from "vuex";
import moment from "moment";

export default {
    components: {
        Footer,
        ReportDefault,
        ReportNgheAn,
        ReportBMT,
        ReportHanoi
    },
    computed: {
        ...mapState(['selected_drawdate', 'user_info']),
    },
    props: {
        region: String,
        playStyle: String
    },
    data() {
        return {
            myCalendar: null
        }
    },
    methods: {
        chooseReportDate() {
            this.myCalendar.open();
        },
        reloadData(){
            let self = this;
            self.$f7.dialog.preloader();
            this.$refs.reportData.loadData();
            setTimeout(function(){
              self.$f7.dialog.close();
            }, 1000);
        }
    },
    mounted() {
        const self = this;
        const app = self.$f7;

        this.myCalendar = app.calendar.create({
            locale: 'vi-VN',
            openIn: 'customModal',
            dateFormat: 'DD/MM/YYYY',
            closeOnSelect: true,
            on: {
                close(c) {
                    self.$store.state.selected_drawdate = moment(c.value[0]);
                }
            }
        });
    }
}
</script>
